import { createContext, useContext } from 'react'

export type CaseContextType = CaseVersion | undefined

/**
 * @deprecated Use useRouteForCase, useRouteForCaseAndClient instead
 */
const CaseContext = createContext<CaseContextType>(undefined)
const CaseContextConsumer = CaseContext.Consumer
const CaseContextProvider = CaseContext.Provider
CaseContext.displayName = 'CaseContext'

/**
 * @deprecated Use useRouteForCase, useRouteForCaseAndClient instead
 */
export const useCaseContext = (canBeEmpty?: boolean) => {
  const context = useContext<CaseContextType>(CaseContext)
  if (!context && !canBeEmpty) {
    throw new Error('useCaseContext must be used within CaseContextProvider')
  }
  return context
}

export { CaseContext, CaseContextConsumer, CaseContextProvider }
